import { Box, useTheme } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useEffect, useState } from "react";
// import { tokens } from "../../../../theme";
// import { tokens } from "../../../../../../theme";

// import Subheading from "../../../../../../components/theme/text/Subheading";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { tokens } from "../../../../../theme";
import { UserPrivileges } from "../../../../../utils/permissions";
import BoolSetting from "../../../../../components/global/Settings/BoolSetting";
import { useGetSettingsForRelationQuery } from "../../../../../newapi/global/generalApiSlice";
import { useGetWebshopCredentialsSelectQuery } from "../../../../../newapi/webshop/webshopSlice";
import Subheading from "../../../../../components/theme/text/Subheading";
import Text from "../../../../../components/theme/text/Text";
import NumberSetting from "../../../../../components/global/Settings/NumberSetting";
import StringSetting from "../../../../../components/global/Settings/StringSetting"
import Heading from "../../../../../components/theme/text/Heading";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import DropdownSetting from "../../../../../components/global/Settings/DropdownSetting";
import ButtonSetting from "../../../../../components/global/Settings/ButtonSetting";
import SettingsSaveButton from "../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../components/global/Settings/useManualSettingsSave";
import { countriesForDropdown } from "../../../../../utils/countries";
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import MEditPortalLogo from "../../../../../components/global/Modals/MEditPortalLogo";

const PortalSettings = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    const location = useLocation();
    const environment = useSelector((state) => state.settings.environment);

    // Switch the parent TabView3 to the Return Costs tab via its ?view= param.
    const goToReturnCosts = () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("view", "return_costs");
        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    };
    const language = useSelector((state) => state.settings.language);
    const countries = countriesForDropdown(language);
    const [showAddress, setShowAddress] = useState(false);
    const [init, setInit] = useState(false);
    const [portalLogoOpen, setPortalLogoOpen] = useState(false);

    const { data: settings} = useGetSettingsForRelationQuery(environment.selectedId, {skip: !environment?.selectedId});
    const { data: webshops } = useGetWebshopCredentialsSelectQuery({ relationId: environment.selectedId, includeIntegrator: true }, { skip: !environment?.selectedId });
    const { handleChange: handleSettingChange, hasChanges, isSaving, save } = useManualSettingsSave();
    
    const webshopObjects = [
        { id: -1, name: t("self_created") },
        ...(webshops ?? []).map((webshop) => ({ id: webshop.id, name: `${webshop.webshop_type} - ${webshop.description}` })),
    ];

    // Caps the "amount of labels" dropdown a customer sees in the return portal; left unset the
    // portal falls back to 2.
    const labelAmountOptions = Array.from({ length: 10 }, (_, index) => ({ id: index + 1, name: `${index + 1}` }));

    useEffect(() => {
        props.replaceView({
            ...props.config,
        },);

        return () => {};
    }, []);

    const handleChange = async (value) => {
        setShowAddress(value);
        //console.log(settings?.find(obj => obj.key === "return_portal_custom_address"));
        //console.log(settings?.find(obj => obj.key === "return_portal_custom_address").value);
        //if(settings) setShowAddress(settings.find(obj => obj.key === "return_portal_custom_address")?.value === 'true' ?? false)
    }

    useEffect(() => {
        if(settings && !init){
            setInit(true);
            const setting = settings.find(obj => obj.key === "return_portal_address_custom");
            if(setting){
                setShowAddress(setting.value === "true");
            }
        }
    },[settings]);

    return (
        <Box
            sx={{
                height: 1,
                "@media screen and (max-width: 47.9375em)": {
                paddingTop: 0,
                paddingX: 0,
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: 1,
                    overflow: "hidden",
                    
                    paddingX: 4,
                    paddingTop: 4,
                    height: 1,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    {/* The heading is the part that gives way on a phone; the save action has to
                        stay reachable there, so the breakpoint sits on the text rather than on the row. */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                            "@media screen and (max-width: 47.9375em)": {
                                display: "none",
                            },
                        }}
                    >
                        <Heading>{t("returnportalsettings")}</Heading>
                        <Text light>{t("returnportalsettings_subtitle")}</Text>
                    </Box>
                    <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
                </Box>


                <Box
                    sx={{
                        mt:2,
                        pt:3,
                        display:"flex",
                        flexDirection:"column",
                        gap:3,
                        borderTopRightRadius:16,
                        borderTopLeftRadius:16,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 4px 8px ${colors.grey[200]}`,
                        px:3,
                        py:2,
                        borderRadius:4,
                    }}
                >
                    
                    <StringSetting
                        manualSave
                        onChange={handleSettingChange}
                        relationId={environment.selectedId}
                        maxWidth={240} 
                        variant={"default"} 
                        settings={settings} 
                        skey="return_portal_name"
                        inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                        }}
                    />

                    <ButtonSetting
                        title="return_portal_return_cost_title"
                        subtitle="return_portal_return_cost_moved_subtitle"
                        btnText={t("return_costs")}
                        onClick={goToReturnCosts}
                        color="purple"
                        endIcon={<OpenInNewOutlinedIcon />}
                        maxWidth={200}
                    />
                    {/* <Box sx={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:4 }}>
                        <Box sx={{ display:"flex", flexDirection:"column" }}>
                            <Text semibold>{t('return_portal_return_cost_title')}</Text>
                            <Text light>{t('return_portal_return_cost_subtitle')}</Text>
                        </Box>
                        <ShLabel
                            fitted
                            clickable
                            palette="normal"
                            variant="purple"
                            size={32}
                            onClick={goToReturnCosts}
                        >
                            {t('return_cost_moved_to_return_costs')}
                        </ShLabel>
                    </Box> */}
                    <NumberSetting
                        manualSave
                        hideSaveButton
                        onChange={handleSettingChange}
                        relationId={environment.selectedId}
                        maxWidth={240}
                        settings={settings}
                        variant={"default"}
                        skey="return_portal_return_days"
                        inputSX={{
                            backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                        }}
                        btnSx ={{
                            backgroundColor: theme.palette.mode === "dark" ? colors.grey[600] : null
                        }}
                    />
                    <DropdownSetting
                        manualSave
                        onChange={handleSettingChange}
                        relationId={environment.selectedId}
                        settings={settings}
                        objects={labelAmountOptions}
                        valueKey="id"
                        maxWidth={240}
                        noselection={"choose"}
                        skey="return_portal_max_labels"
                    />
                    <DropdownSetting
                        manualSave
                        onChange={handleSettingChange}
                        multiple
                        allowSelectAll
                        relationId={environment.selectedId}
                        settings={settings}
                        objects={webshopObjects}
                        valueKey="id"
                        maxWidth={280}
                        noselection={"choose"}
                        searchOptions={{ enabled: true, placeholder: t("search") }}
                        skey="return_portal_fullname_webshops"
                    />
                    <ButtonSetting
                        title="return_portal_logo"
                        subtitle="return_portal_logo_description"
                        btnText={t("edit")}
                        onClick={() => setPortalLogoOpen(true)}
                        endIcon={<PaletteOutlinedIcon />}
                        maxWidth={200}
                    />
                    <MEditPortalLogo data={props.data} open={portalLogoOpen} handleClose={() => setPortalLogoOpen(false)} />
                </Box>
                <Box
                    sx={{
                        mt:1,
                        display: "flex",
                        flexDirection: "column",
                        paddingTop: "36px",
                        overflow: "hidden",
                        "@media screen and (max-width: 47.9375em)": {
                            display: "none",
                        },
                    }}
                >
                    <Heading>{t("return_address")}</Heading>
                </Box>


                <Box
                    sx={{
                        mt:2,
                        pt:3,
                        display:"flex",
                        flexDirection:"column",
                        gap:3,
                        borderTopRightRadius:16,
                        borderTopLeftRadius:16,
                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 4px 8px ${colors.grey[200]}`,
                        px:3,
                        py:2,
                        borderRadius:4,
                    }}
                >
                    <BoolSetting
                        manualSave
                        settings={settings}
                        skey="return_portal_address_custom"
                        relationId={environment.selectedId}
                        variant={2}
                        onChange={(value, setting) => {
                            handleChange(value);
                            handleSettingChange(value, setting);
                        }}
                    />
                    {showAddress && (<>
                        <StringSetting
                            manualSave
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            maxWidth={480}
                            variant={2}
                            settings={settings}
                            skey="return_portal_address_street"
                            inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                            }}
                        />
                        <NumberSetting
                            manualSave
                            hideSaveButton
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            maxWidth={240}
                            variant={2}
                            settings={settings}
                            skey="return_portal_address_nr"
                            inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                            }}
                            btnSx ={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[600] : null
                            }}
                        />
                        <StringSetting
                            manualSave
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            maxWidth={480}
                            variant={2}
                            settings={settings}
                            skey="return_portal_address_nr_addition"
                            inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                            }}
                        />
                        <StringSetting
                            manualSave
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            maxWidth={480}
                            variant={2}
                            settings={settings}
                            skey="return_portal_address_postal"
                            inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                            }}
                        />
                        <StringSetting
                            manualSave
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            maxWidth={480}
                            variant={2}
                            settings={settings}
                            skey="return_portal_address_city"
                            inputSX={{
                                backgroundColor: theme.palette.mode === "dark" ? colors.grey[400] : null,
                                borderRadius:4,
                            }}
                        />
                        <DropdownSetting
                            manualSave
                            onChange={handleSettingChange}
                            relationId={environment.selectedId}
                            settings={settings}
                            objects={countries ?? []}
                            maxWidth={480}
                            noselection={"choose"}
                            variant={2}
                            skey="return_portal_address_country"
                            searchOptions={{
                                enabled:true,
                                placeholder:t("search")
                            }}
                        />
                        </>)}               
                </Box>
            </Box>
            
        </Box>
  )
};

export default PortalSettings;